import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wi-fi--sprite",
  "use": "icon-wi-fi--sprite-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-wi-fi--sprite\">\n<path d=\"M8.44902 17.0879C9.52344 16.0135 10.9806 15.4099 12.5001 15.4099C14.0195 15.4099 15.4767 16.0135 16.5511 17.0879M12.5001 20.8337H12.5105M5.13548 13.4681C9.20215 9.40039 15.798 9.40039 19.8657 13.4681M1.45215 9.78477C7.55319 3.68372 17.4469 3.68372 23.549 9.78477\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol